var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"split"},[_c('owner-access-code-list'),_c('owner-new-access-code')],1)}
var staticRenderFns = []

export { render, staticRenderFns }